var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bet-logo",class:{ 'has-link': !!_vm.urlLink },style:({ width: _vm.width, height: _vm.height }),on:{"click":_vm.onClick}},[(_vm.urlLogo)?_c('img',{style:({ width: _vm.width, height: _vm.height }),attrs:{"src":_vm.urlLogo,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }